Postlogin = (function (my) {
    my.Users = {};
    const self = my.Users;
    const lessonSelections = [];
    const $lessonsTable = $('#lessons-table');
    const $mainLicense = $('#license_id');
    const $additionalLicenses = $('#user_license_ids');

    // Ported from bootstrap-select to Tom Select 2026-05-12 as prep
    // for the Bootstrap 5 upgrade. Shared config for the additional-
    // licenses picker. Declared once so the initial init in .init()
    // and the re-init inside checkRole() (after a destroy/recreate)
    // stay in sync.
    const additionalLicensesConfig = {
        placeholder: 'Select any additional licenses',
        plugins: ['remove_button'],
        diacritics: true,
        maxOptions: null,
    };

    self.init = function () {
        // Build the pickers FIRST, then let checkRole() decide
        // whether to disable them based on the currently-selected
        // role. The previous order (checkRole first) double-wrapped
        // $additionalLicenses whenever role 2/3/4 was pre-selected:
        // checkRole() created the Tom Select, then this init
        // unconditionally created another on the same element.
        // Tom Select throws when a <select> is wrapped twice.
        const mainLicenseEl = $mainLicense[0];
        if (mainLicenseEl) {
            // eslint-disable-next-line no-new
            new TomSelect(mainLicenseEl, {
                placeholder: 'Select main license',
                diacritics: true,
                maxOptions: null,
            });
        }

        const additionalLicensesEl = $additionalLicenses[0];
        if (additionalLicensesEl) {
            // eslint-disable-next-line no-new
            new TomSelect(additionalLicensesEl, additionalLicensesConfig);
        }

        // Now apply the role-driven enable/disable state. checkRole's
        // destroy-and-recreate path will no-op-then-rebuild if role
        // is 2/3/4, and its disable path will simply toggle the
        // existing instance for other roles.
        checkRole();

        $('#role_id').on('change', () => {
            checkRole();
        });

        $lessonsTable.closest('form').on('submit', () => {
            const input = $('<input>').attr('type', 'hidden').attr('name', 'lesson_selections').val(lessonSelections);
            $lessonsTable.closest('form').append(input);
        });
    };

    self.addLesson = function (lesson) {
        if (lessonSelections.indexOf(lesson.lesson_id) === -1) {
            lessonSelections.push(lesson.lesson_id);
        }
    };

    self.removeLesson = function (lessonId) {
        if (lessonSelections.indexOf(+lessonId) !== -1) {
            const index = lessonSelections.indexOf(+lessonId);
            lessonSelections.splice(index, 1);
        }
    };

    const checkRole = function () {
        // TODO FIX THIS role and unique identifier is not necessary for some users, so we can possibly remove them?
        // this might be info from when this was attached to myprofile stuff.
        const value = $('#role_id').val();

        if (value > 2) {
            $('#email').closest('.form-group').show();
        } else {
            $('#email').closest('.form-group').hide();
        }

        const grade = $('#grade');
        if (+value === 2) {
            grade.closest('.form-group').show();
            grade.prop('required', true);
        } else {
            grade.closest('.form-group').hide();
            grade.removeAttr('required');
        }

        if (+value === 6) {
            $('#unique_identifier').closest('.form-group').hide();
        } else {
            $('#unique_identifier').closest('.form-group').show();
        }

        // Tom Select port: the previous bootstrap-select code did a
        // destroy/recreate when the user switched into a role that
        // uses additional licenses (2/3/4), so the picker reflected
        // any <option>s that had been mutated by the server render
        // or by prior script. Tom Select needs the same cycle — its
        // internal options cache is built from the native <select>
        // at construction time. destroy() clears the chrome, then a
        // fresh instance re-reads the now-current <option>s.
        const additionalEl = $additionalLicenses[0];
        if (+value === 2 || +value === 3 || +value === 4) {
            $additionalLicenses.prop('disabled', false);
            if (additionalEl && additionalEl.tomselect) {
                additionalEl.tomselect.destroy();
            }
            if (additionalEl) {
                // eslint-disable-next-line no-new
                new TomSelect(additionalEl, additionalLicensesConfig);
            }
        } else {
            $additionalLicenses.prop('disabled', true);
            if (additionalEl && additionalEl.tomselect) {
                // .disable() greys out the control, matching the
                // previous selectpicker('refresh') after disabling.
                // .sync() re-reads native <option>s in case any were
                // added/removed while disabled.
                additionalEl.tomselect.sync();
                additionalEl.tomselect.disable();
            }
        }
    };

    return my;
}(Postlogin || {}));
